// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1lnCC","paddingWrapper":"styles_paddingWrapper__2YuaC","otsdkshowsettings":"styles_otsdkshowsettings__3fFYb"};